import { useMediaQuery, useTheme } from '@mui/material';

const Mobile = ({ breakpoint = 'md', children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(breakpoint));
  return isMobile ? children : null;
};

export default Mobile;
